import * as Yup from "yup";
import {toast} from "react-toastify";
import React, {useEffect, useRef, useState} from "react";
import {Form} from "@unform/web";
import {Link, useHistory} from "react-router-dom";
import {BiArrowBack} from "react-icons/bi";
import {IoMdCheckmark} from "react-icons/io";
import {MdInsertPhoto} from "react-icons/md";
import {InputAdornment} from "@material-ui/core";
import InputMask from "../../../components/Form/InputMask";
import InputSelect from "../../../components/Form/InputSelect";
import CustomButton from "../../../components/Form/Button";
import messageTypes from "../../../constants/MessagesTypes";
import currencyPairTypes from "../../../constants/CurrencyPairTypes";
import {edit, find, save} from "../../../services/Trading";
import {useDispatch, useSelector} from "react-redux";
import {getBank} from "../../../services/Bank";
import {actions} from "../../../redux/actions";
import InputDate from "../../../components/Form/InputDate";
import {currencyFormat} from "../../../utils/masks";
import {getStrategies} from "../../../services/Strategy";
import swal from "@sweetalert/with-react";
import {useTranslation} from "react-i18next";
import FormTextarea from "../../../components/Form/FormTextarea";
import {getCurrencyPairs} from "../../../services/CurrencyPair";
import {IoAddCircle} from "react-icons/io5";
import InputSelectAutoComplete from "../../../components/Form/InputSelectAutoComplete";
import DivDiagonal from "../../../components/DivDiagonal";
import {TradingListPageHeader} from "../styles";
import {
    TradingNewWrapper,
    ContentArea,
    TradingNewFormWrap,
    TradingFormCard,
    StyledFormWrapper,
    PhotoSection,
    PhotoPreview,
    PhotoInfo,
    ButtonContainer,
    VisuallyHiddenInput,
    CurrencyPairRow,
    AddPairButton,
    FormRow,
} from "./styles";

const backBtnStyle = {
    background: 'rgba(255, 255, 255, 0.05)',
    border: '2px solid rgba(255, 255, 255, 0.2)',
    color: '#e0e0e0',
    padding: '14px 28px',
    borderRadius: '10px',
    fontWeight: 600,
    transition: 'all 0.3s ease',
};

const saveBtnStyle = {
    background: 'linear-gradient(135deg, #f29205 0%, #ff6b35 100%)',
    border: 'none',
    color: '#ffffff',
    padding: '14px 32px',
    borderRadius: '10px',
    fontWeight: 600,
    boxShadow: '0 4px 15px rgba(242, 146, 5, 0.3)',
    transition: 'all 0.3s ease',
};

const pickImageBtnStyle = {
    background: 'rgba(255, 255, 255, 0.05)',
    border: '2px solid rgba(0, 212, 255, 0.2)',
    color: '#00d4ff',
    padding: '12px 24px',
    borderRadius: '10px',
    fontWeight: 600,
    textTransform: 'none',
    transition: 'all 0.3s ease',
};

export default function NewTrading({match}) {
    const [loading, setLoading] = useState(false);
    const [trading, setTrading] = useState(0);
    const [strategies, setStrategies] = useState(null);
    const formRef = useRef(null);
    const history = useHistory();
    const dispatch = useDispatch();
    const { coinType } = useSelector((state) => state.BankReducer);
    const { t } = useTranslation();
    const [image, setImage] = useState(null);
    const [currencyPairs, setCurrencyPairs] = useState([]);

    const directionTrading = [
        {key: 'COMPRA', value: t('trading_label_input_direction_select_option_1')},
        {key: 'VENDA', value: t('trading_label_input_direction_select_option_2')},
    ];

    useEffect(() => {
        getCurrencyPairs({ full: 1 }).then((response) => {
            if (!response || response === '') {
                setCurrencyPairs([...currencyPairTypes]);
                return;
            }

            const newListCurrencyPair = [...currencyPairTypes];
            response.data.data.forEach((pair) => {
                newListCurrencyPair.push({key: pair.name, value: pair.name});
            });

            setCurrencyPairs(newListCurrencyPair);
        });

        return function cleanup() {
            setCurrencyPairs([]);
        };
    }, []);

    async function handleSaveNewTrading(data) {
        try {

            if (loading) {
                return;
            }

            setDataTrading(data);

            setLoading(true);
            formRef.current.setErrors({});
            const schema = Yup.object().shape({
                investmentValue: Yup.string().required(t('input_required')),
                profitObtained: Yup.string().required(t('input_required')),
                currencyPair: Yup.string().required(t('input_required')),
                created: Yup.string().required(t('input_required')),
            });

            await schema.validate(data, {
                abortEarly: false,
            });

            const formData = new FormData();
            if (data.observation) {
                formData.append('observation', data.observation);
            }

            if (data.direction) {
                formData.append('direction', data.direction);
            }
            formData.append('investmentValue', data.investmentValue.replace(/[^0-9,-]*/g, '').replace(',', '.'));
            formData.append('profitObtained', data.profitObtained.replace(/[^0-9,-]*/g, '').replace(',', '.'));
            formData.append('currencyPair', data.currencyPair);
            formData.append('strategy', data.strategy);
            formData.append('created', data.created);

            if (image && image !== '') {
                formData.append('image', image);
            }

            const response = (trading) ? await edit(trading.id, formData) : await save(formData);

            if (response && response.status === 200) {
                toast.success(messageTypes.SUCCESS);
                getBank().then((data) => {
                    dispatch(actions.updateBank(data));

                    const meta = data.meta;
                    if (!meta) {
                        return;
                    }

                    const profitObtainedToday = parseFloat(data.profitObtainedToday);
                    if (profitObtainedToday >= parseFloat(meta.stopWin)) {
                        swal(
                            {
                                icon: "success",
                                title: t('trading_goal_stop_win'),
                            }
                        );
                    } else if (profitObtainedToday <= parseFloat(meta.stopLoss)) {
                        swal(
                            {
                                icon: "warning",
                                title: t('trading_goal_stop_loss'),
                            }
                        );
                    }
                });
                history.push('/trading');
            } else {
                toast.error(messageTypes.ERROR_SAVE);
            }

            setLoading(false);

        } catch (err) {
            setLoading(false);
            if (err instanceof Yup.ValidationError) {
                const validationErrors = {};
                err.inner.forEach((error) => {
                    validationErrors[error.path] = error.message;
                });
                formRef.current.setErrors(validationErrors);
                toast.warning(messageTypes.REQUIRED_FIELDS);
                return;
            }

            toast.error(messageTypes.ERROR);
        }
    }

    function setDataTrading(data) {
        if (trading) {
            trading.currencyPair = data.currencyPair;
            trading.investmentValue = data.investmentValue;
            trading.profitObtained = data.profitObtained;
            setTrading(trading);
        }
    }

    useEffect(() => {
        const id = match.params.id;
        if (id) {
            setLoading(true);
            find(id).then((data) => {
                setTrading(data);
            }).finally(() => setLoading(false));
        } else {
            setTrading(0);
        }

        getStrategies().then((data) => {
            if (data && data.data && data.data.data && data.data.data.length) {
                const list = data.data.data;
                const arrayList = [];
                for (const index in list) {
                    const strategy = list[index];
                    arrayList.push({
                        key: strategy.id,
                        value: strategy.name
                    });
                }
                setStrategies(arrayList);
            } else {
                setStrategies([]);
            }
        });
    }, [match.params.id]);

    function alertImageSize() {
        swal({
            text: t('fundamentalist_limit_img'),
        });
    }

    function showImage(urlImage, currencyPair) {
        swal(
            {
                showCloseButton: true,
                className: 'trading-modal',
                confirmButtonText: 'Fechar',
                content: <div>
                    <h3 className={"font-weight-bolder"}>{currencyPair}</h3>
                    <br/>
                    <div className={"img-trading-modal"}>
                        <img src={urlImage} width={'80%'} height={"80%"} alt={'Imagem da negociação'}/>
                    </div>
                </div>,
            }
        );
    }

    const isEdit = Boolean(trading && typeof trading === 'object' && trading.id);
    const showForm = !loading && (isEdit || trading === 0);

    return (
        <TradingNewWrapper>
            <DivDiagonal />
            <ContentArea>
                {showForm && (
                    <>
                    <TradingListPageHeader>
                        <h1>
                            {isEdit ? (
                                <>
                                    <i className="fas fa-edit" aria-hidden="true"/> {t('traging_card_add_title')}
                                </>
                            ) : (
                                <>
                                    <i className="fas fa-plus" aria-hidden="true"/> {t('traging_card_edit_title')}
                                </>
                            )}
                        </h1>
                    </TradingListPageHeader>
                    <TradingNewFormWrap>
                    <TradingFormCard>
                        <StyledFormWrapper>
                            <Form ref={formRef} onSubmit={handleSaveNewTrading}>
                                <div className="row">
                                    <div className="col-12 col-md-6 mt-3 mt-md-4">
                                        <FormRow>
                                            <InputDate
                                                name="created"
                                                label={t('trading_label_input_date') + ' *'}
                                                value={(isEdit) ? new Date(trading.created.date) : new Date()}
                                            />
                                        </FormRow>
                                    </div>
                                    <div className="col-12 col-md-6 mt-3 mt-md-4">
                                        <FormRow>
                                            <CurrencyPairRow>
                                                <div>
                                                    <InputSelectAutoComplete
                                                        type="text"
                                                        name="currencyPair"
                                                        label={t('trading_label_input_currency_pair') + ' *'}
                                                        options={currencyPairs}
                                                        defaultValue={isEdit ? trading.currencyPair : ''}
                                                    />
                                                </div>
                                                <AddPairButton
                                                    type="button"
                                                    onClick={() => history.push('/currency-pair/new')}
                                                    title={t('add')}
                                                    aria-label={t('add')}
                                                >
                                                    <IoAddCircle size={28}/>
                                                </AddPairButton>
                                            </CurrencyPairRow>
                                        </FormRow>
                                    </div>
                                </div>

                                <div className="row">
                                    <div className="col-12 col-md-6 mt-3">
                                        <FormRow>
                                            <InputMask
                                                type="text"
                                                name="investmentValue"
                                                placeholder="0,00"
                                                label={t('trading_label_input_value_invested') + ' *'}
                                                mask={'currency'}
                                                defaultValue={(isEdit) ? currencyFormat(trading.investmentValue) : null}
                                                InputProps={{
                                                    startAdornment: <InputAdornment position="start">{coinType}</InputAdornment>,
                                                }}
                                            />
                                        </FormRow>
                                    </div>
                                    <div className="col-12 col-md-6 mt-3">
                                        <FormRow>
                                            <InputMask
                                                className="inputProfitObtained"
                                                type="text"
                                                name="profitObtained"
                                                placeholder="0,00"
                                                label={t('trading_label_input_profit_prejudice') + ' *'}
                                                mask={'currency'}
                                                defaultValue={(isEdit) ? currencyFormat(trading.profitObtained) : null}
                                                InputProps={{
                                                    startAdornment: <InputAdornment position="start">{coinType}</InputAdornment>,
                                                }}
                                            />
                                        </FormRow>
                                    </div>
                                </div>

                                <div className="row">
                                    <div className="col-12 col-md-6 mt-3">
                                        <FormRow>
                                            <InputSelect
                                                type="text"
                                                name="direction"
                                                label={t('trading_label_input_direction')}
                                                options={directionTrading}
                                                defaultValue={isEdit && trading.direction ? trading.direction : ''}
                                            />
                                        </FormRow>
                                    </div>
                                    <div className="col-12 col-md-6 mt-3">
                                        <FormRow>
                                            {strategies && (
                                                <CurrencyPairRow>
                                                    <div>
                                                        <InputSelect
                                                            type="text"
                                                            name="strategy"
                                                            label={t('trading_label_input_strategy')}
                                                            options={strategies}
                                                            defaultValue={isEdit && trading.strategy ? trading.strategy.id : ''}
                                                        />
                                                    </div>
                                                    <AddPairButton
                                                        type="button"
                                                        onClick={() => history.push('/estrategia/new')}
                                                        title={t('add')}
                                                        aria-label={t('add')}
                                                    >
                                                        <IoAddCircle size={28}/>
                                                    </AddPairButton>
                                                </CurrencyPairRow>
                                            )}
                                        </FormRow>
                                    </div>
                                </div>

                                <div className="row">
                                    <div className="col-12 mt-3">
                                        <FormRow>
                                            <FormTextarea
                                                name="observation"
                                                defaultValue={isEdit ? trading.observation : ''}
                                                label={t('trading_label_observation')}
                                                placeholder={t('trading_placeholder_observation')}
                                            />
                                        </FormRow>
                                    </div>
                                </div>

                                <PhotoSection>
                                    {(isEdit && trading.image) || image ? (
                                        <PhotoPreview
                                            onClick={() => {
                                                if (isEdit && trading.image) {
                                                    showImage(`${process.env.REACT_APP_API_ENDPOINT}/${trading.image}`, trading.currencyPair);
                                                }
                                            }}
                                            style={{ cursor: (isEdit && trading.image) ? 'pointer' : 'default' }}
                                        >
                                            <img
                                                src={image ? URL.createObjectURL(image) : `${process.env.REACT_APP_API_ENDPOINT}/${trading.image}`}
                                                alt={t('trading_image')}
                                            />
                                        </PhotoPreview>
                                    ) : null}
                                    <PhotoInfo>
                                        <span className="photo-label">
                                            {isEdit && trading.image ? t('trading_edit_image') : t('trading_image')}
                                        </span>
                                        <CustomButton
                                            component="label"
                                            role={undefined}
                                            variant="outlined"
                                            tabIndex={-1}
                                            startIcon={<MdInsertPhoto />}
                                            style={pickImageBtnStyle}
                                            onMouseEnter={(e) => {
                                                e.currentTarget.style.background = 'rgba(0, 212, 255, 0.1)';
                                                e.currentTarget.style.borderColor = 'rgba(0, 212, 255, 0.4)';
                                                e.currentTarget.style.transform = 'translateY(-2px)';
                                            }}
                                            onMouseLeave={(e) => {
                                                e.currentTarget.style.background = 'rgba(255, 255, 255, 0.05)';
                                                e.currentTarget.style.borderColor = 'rgba(0, 212, 255, 0.2)';
                                                e.currentTarget.style.transform = 'translateY(0)';
                                            }}
                                        >
                                            {(isEdit && trading.image) || image
                                                ? t('trading_edit_image')
                                                : t('trading_image')}
                                            <VisuallyHiddenInput
                                                type="file"
                                                accept="image/*"
                                                onChange={(event) => {
                                                    const file = event.target.files[0];
                                                    const maxSizeInBytes = 2 * 1024 * 1024;
                                                    if (file && file.size > maxSizeInBytes) {
                                                        alertImageSize();
                                                        event.target.value = null;
                                                        return;
                                                    }
                                                    setImage(event.target.files[0]);
                                                }}
                                            />
                                        </CustomButton>
                                        {image && (
                                            <div className="photo-selected">
                                                {t('trading_image')}: <strong>{image.name}</strong>
                                            </div>
                                        )}
                                    </PhotoInfo>
                                </PhotoSection>

                                <ButtonContainer>
                                    <Link to="/trading" style={{ textDecoration: 'none' }}>
                                        <CustomButton
                                            variant="outlined"
                                            className="btn btn-secondary font-weight-bold text-capitalize mobile-button"
                                            startIcon={<BiArrowBack/>}
                                            style={backBtnStyle}
                                            onMouseEnter={(e) => {
                                                e.currentTarget.style.background = 'rgba(255, 255, 255, 0.1)';
                                                e.currentTarget.style.borderColor = 'rgba(255, 255, 255, 0.3)';
                                                e.currentTarget.style.transform = 'translateY(-2px)';
                                            }}
                                            onMouseLeave={(e) => {
                                                e.currentTarget.style.background = 'rgba(255, 255, 255, 0.05)';
                                                e.currentTarget.style.borderColor = 'rgba(255, 255, 255, 0.2)';
                                                e.currentTarget.style.transform = 'translateY(0)';
                                            }}
                                        >
                                            {t('btn_back')}
                                        </CustomButton>
                                    </Link>
                                    <CustomButton
                                        className="btn btn-primary font-weight-bold text-capitalize mobile-button"
                                        loading={loading}
                                        type="submit"
                                        startIcon={<IoMdCheckmark/>}
                                        style={saveBtnStyle}
                                        onMouseEnter={(e) => {
                                            if (!loading) {
                                                e.currentTarget.style.transform = 'translateY(-2px)';
                                                e.currentTarget.style.boxShadow = '0 6px 20px rgba(242, 146, 5, 0.4)';
                                            }
                                        }}
                                        onMouseLeave={(e) => {
                                            e.currentTarget.style.transform = 'translateY(0)';
                                            e.currentTarget.style.boxShadow = '0 4px 15px rgba(242, 146, 5, 0.3)';
                                        }}
                                    >
                                        {t('btn_save')}
                                    </CustomButton>
                                </ButtonContainer>
                            </Form>
                        </StyledFormWrapper>
                    </TradingFormCard>
                    </TradingNewFormWrap>
                    </>
                )}
            </ContentArea>
        </TradingNewWrapper>
    );
}
